import { useState, useCallback, useRef, useEffect } from 'react';
export function useBusy() {
    var _a = useState(0), counter = _a[0], setCounter = _a[1];
    var mounted = useRef(false);
    var setBusy = useCallback(function (busy) {
        setCounter(function (counter) {
            return busy ? counter + 1 : counter - 1;
        });
    }, [setCounter]);
    useEffect(function () {
        mounted.current = true;
        return function () {
            mounted.current = false;
        };
    }, []);
    return [counter > 0, mounted ? setBusy : function () { }];
}
//# sourceMappingURL=useBusy.js.map